<script setup>
const props = defineProps({
	ages: { type: Array, required: true },
	activeIndex: { type: Number, required: true },
	ageOptions: { type: Array, required: true },
	label: { type: String, required: true },
	selectAgePrompt: { type: String, required: true },
	showCount: { type: Boolean, default: false },
	type: { type: String, required: true }
});

const emit = defineEmits(['setActiveIndex', 'setAge', 'removeAge']);
</script>

<template>
  <div
    class="abPassengers__group abPassengers__group--ages"
    :class="{
      'block': showCount,
      'line-1': activeIndex >= 0 && activeIndex <= 2,
      'line-2': activeIndex >= 3 && activeIndex <= 5,
      'line-3': activeIndex >= 6 && activeIndex <= 9,
      'visible': showCount
    }"
  >
    <div class="abPassengers__selectAges">
      <span>{{ selectAgePrompt }}</span>
    </div>

    <!-- Age badges -->
    <div class="abPassengers__ages">
      <div
        v-for="(age, index) in ages"
        :key="index"
        class="abPassengers__age abPassengers__age--visible"
        :class="{ 'abPassengers__age--active': activeIndex === index }"
        @click="emit('setActiveIndex', index)"
      >
        <!-- Delete button -->
        <!-- Don't show if youth and first index -->
        <button
          v-if="!(index === 0 && type === 'youth' && ages.length === 1)"
          class="abPassengers__ageDelete"
          @click.stop="emit('removeAge', index)"
        >
          <span class="icon icon-circle-cross" aria-hidden="true" />
        </button>
        <span>{{ label }} {{ index + 1 }}</span>
        <span v-if="age === null">{{ $l('searchBox.passengers.selectAge') }}</span>
        <template v-else>
          <slot name="age-display" :age="age">
            <span>{{ age }} {{ $l('searchBox.passengers.yearsOld') }}</span>
          </slot>
        </template>
      </div>
    </div>

    <!-- Age picker -->
    <div v-show="activeIndex !== -1" class="abPassengers__ranges">
      <div class="abPassengers__scroller">
        <div
          v-for="ageOption in ageOptions"
          :key="ageOption"
          role="menuitem"
          class="abPassengers__range"
          :class="{ 'abPassengers__range--active': ages[activeIndex] === ageOption }"
          tabindex="0"
          :aria-label="$lreplace('ariaLabels.selectYouthAge', { s: ageOption })"
          @click="emit('setAge', ageOption)"
          @keydown.enter="emit('setAge', ageOption)"
        >
          <slot name="age-option" :age="ageOption">
            <span>{{ ageOption }}</span>
            <span>{{ $l('searchBox.passengers.yearsOld') }}</span>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss">
.abPassengers__ageDelete {
  position: absolute;
  top: 4px;
  right: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;

  .icon {
    width: 12px;
    height: 12px;
    color: $main-font-color;
  }

  &:hover .icon {
    color: $main-font-color;
  }
}
</style>
